export default "__VITE_ASSET__16856a6f__"